import { render } from "./round-1.vue?vue&type=template&id=4d4b6c26"
import script from "./round-1.vue?vue&type=script&lang=js"
export * from "./round-1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__